/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Button, Grid, MenuItem, Popover, Tooltip, Typography, useMediaQuery, Zoom } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
//
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnIconExcel, BtnIconSearch, BtnSearch } from 'components/Common/Button';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import Accordion from 'components/Common/Accordion/Accordion';
import DateRangePicker from 'components/Common/ElementInForm/DateRange';
import moment from 'moment';
import {
    DataGridMui as Table,
    initRows,
    PaginationInterface,
} from "components/Common/Table/DataGridMui";
import { GridColumns } from '@mui/x-data-grid-pro';
import { Link } from 'react-router-dom';
import { AxiosPost, AxiosPostFileExcel, ResultAPI } from 'service/CommonFunction/TS_function';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';

const BAUpdatePlan = (props) => {

    const { GetDashboard, CardAction, Option } = props;
    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const Layout900 = useMediaQuery('(min-width:900px)');

    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dIssueDate",
        sSortDirection: "desc"
    });
    //#region  Form
    let objSchema = {
        sJobCode: yupFormSchemas.string("เลขที่ใบงาน", { required: false }),
        sVOCFormCode: yupFormSchemas.string("เลขที่ใบแจ้ง", { required: false }),
        sCustomer: yupFormSchemas.string("รายละเอียด", { required: false }),
        sDetail: yupFormSchemas.string("รายละเอียด", { required: false }),
        arrDateIssue: yupFormSchemas.stringArray("วันที่แจ้ง", { required: false }),
        arrJobType: yupFormSchemas.object("สถานะใบงาน", { required: false }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    useEffect(() => {
        if (props.CardAction == 6 || props.CardAction == 13 || props.CardAction == 16) {
            loadData()
        }
    }, [props.CardAction])

    const loadData = (p: PaginationInterface = dataRow) => {
        // BlockUI();
        setLoadingTable(true)
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        let obj = {
            ...p,
            "sJobCode": form.getValues("sJobCode") ?? null,
            "sLanguage": "th",
            "nCardBox": props.CardAction,
            "lstVOCJobTypeID": form.getValues("arrJobType") ? form.getValues("arrJobType") : null,
            "sCustomer": form.getValues("sCustomer") ?? null,
            "sVOCFormCode": form.getValues("sVOCFormCode") ?? null,
            "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
            "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
        }
        AxiosPost(`VOC/SearchVOCFormIssue`, obj, (res) => {
            // UnBlockUI();
            ResultAPI(res, null, () => {
                setLoadingTable(false)
                setDataRow({
                    ...p,
                    arrRows: res.result.data || [],
                    nDataLength: res.result.nDataLength,
                    nPageIndex: res.result.nPageIndex,
                });
            })
        }, () => {
            setLoadingTable(false)
        })
        if (GetDashboard) {
            GetDashboard()
        }
    };

    const ExportFile = (p: PaginationInterface = dataRow) => {
        let Param = {
            ...p,
            "sJobCode": form.getValues("sJobCode") ?? null,
            "sLanguage": "th",
            "nCardBox": props.CardAction,
            "lstVOCJobTypeID": form.getValues("arrJobType") ? form.getValues("arrJobType") : null,
            "sCustomer": form.getValues("sCustomer") ?? null,
            "sVOCFormCode": form.getValues("sVOCFormCode") ?? null,
            "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("DD/MM/YYYY") + "" : null,
            "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("DD/MM/YYYY") + "" : null,
            "sFileName": `รายงานจัดทำแผนการแก้ไข_${moment().format("DDMMYYYYHHmmss")}`,
            "lstHeadName": ["ที่", "เลขที่ใบงาน", "ประเภทใบงาน", "เลขที่ใบแจ้ง", "วันที่แจ้ง", "กลุ่มตลาด", "บริษัท", "ลูกค้า", "ผู้เปิดใบงาน", "วันที่เปิดใบงาน"],
            "lstHeadWidth": [15, 20, 18, 20, 25, 25, 40, 20, 20, 20],
            "isExport": true,
        }
        let sFileName = `รายงานจัดทำแผนการแก้ไข_${moment().format("DDMMYYYYHHmmss")}`;
        AxiosPostFileExcel(`Export/ExportHomeVOC`, Param, sFileName, null, null, BlockUI, UnBlockUI)
    }

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 50,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sJobCode",
            headerName: "เลขที่ใบงาน",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (item) => {
                let nJobTypeID = item.row?.nJobTypeID;
                let nVOCFormTypeID = item.row?.nVOCFormTypeID;
                return (
                    <>
                        <Link
                            to={nVOCFormTypeID == 2 ? "/Backend/HomeBackEnd/PageProductAndService" : nJobTypeID === 1 ? "/Backend/HomeBackEnd/PageComplaint" : nJobTypeID === 2 ? "/Backend/HomeBackEnd/PageRequest" : "/Backend/HomeBackEnd/PageSuggest"}
                            state={{
                                sVOCFormID: item.row.sVOCFormID,
                                sJobCode: item.row.sJobCode,
                                nCard : CardAction,
                            }}
                            style={{ color: "#228dbd", textDecoration: "underline", cursor: "pointer" }}
                        >
                            {item.value}
                        </Link>
                    </>
                );
            },
        },

        {
            field: "sJobType",
            headerName: "ประเภทใบงาน",
            headerAlign: "center",
            flex: 1.5,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
        },
        {
            field: "sVOCFormCode",
            headerName: "เลขที่ใบแจ้ง",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "dIssueDate",
            headerName: "วันที่แจ้ง",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;

                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            field: "sBA",
            headerName: "กลุ่มตลาด",
            headerAlign: "center",
            flex: 1.5,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
        },
        {
            field: "sCompanyName",
            headerName: "บริษัท",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (item) => {
                return (
                    <Tooltip title={item.value} TransitionComponent={Zoom} placement="top-start" >
                        <Typography component={"label"}>{item.value} </Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: "sCustomerName",
            headerName: "ลูกค้า",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "sOpenIssueName",
            headerName: "ผู้เปิดใบงาน",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "dCreate",
            headerName: "วันที่เปิดใบงาน",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;

                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        }
    ];

    return (
        <>
            <FormProvider {...form}>
                <Accordion header={"จัดทำแผนการแก้ไข"}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                        <Grid item xs={12}>
                            <Grid container spacing={1} direction="row" justifyContent={Layout900 ? "end" : "start"} alignItems="center" >
                                <Grid item xs={12} sm={6} md={1.5}>
                                    <InputFormItem
                                        id="sJobCode"
                                        name="sJobCode"
                                        label="เลขที่ใบงาน"
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={1.5}>
                                    <InputFormItem
                                        id="sVOCFormCode"
                                        name="sVOCFormCode"
                                        label="เลขที่ใบแจ้ง"
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DateRangePicker
                                        label="วันที่แจ้ง (เริ่มต้น)"
                                        lableEnd="วันที่แจ้ง (สิ้นสุด)"
                                        require={false}
                                        name="arrDateIssue"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>
                                    <InputFormItem
                                        id="sCustomer"
                                        name="sCustomer"
                                        label="ลูกค้า"
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                {/* <Grid item xs={12} sm={6} md={2}>
                                    <MultiSelectForm
                                        name="arrJobType"
                                        options={Option.lstVOCJobType || []}
                                        label={"ประเภทใบงาน"}
                                        required={false}
                                    />
                                </Grid> */}
                                <Grid item xs={12} md={'auto'}>
                                    <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                        <Grid item>
                                            <BtnIconSearch onClick={() => { loadData() }} />
                                        </Grid>
                                        <Grid item>
                                            <BtnIconExcel onClick={() => { ExportFile() }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Table
                                isLoading={loadingTable}
                                OnLoadData={(p) => loadData(p)}
                                Rows={dataRow}
                                HiddenToolHead={true}
                                Columns={dataColumn}
                                backgroundHeaderCustom={"#004290"}
                                sxCustomHeader={{ color: '#ffffff' }}
                            />
                        </Grid>
                    </Grid>
                </Accordion>
            </FormProvider>
        </>
    )
}

export default BAUpdatePlan